








import { Component, Vue } from "vue-property-decorator";

// @components
import DataTable from "@/components/Settings/CompanyList/DataTable.vue";

//  modules

@Component({
  components: {
    DataTable,
  },
})
export default class CompanyList extends Vue {
  // @Data
  get themeClass(): string {
    return this.$vuetify.theme.dark ? "theme--dark" : "theme--light";
  }
}
